<template>
  <b-container>
    <h1 v-translate>New Warehouse</h1>
    <location-form type="warehouses" @success="emitSuccess" />
  </b-container>
</template>

<script>
import LocationForm from '@/components/LocationForm'

export default {
  name: 'NewWarehouse',
  components: {
    LocationForm
  },
  methods: {
    emitSuccess() {
      this.$router.push('/list/warehouses')
    }
  }
}
</script>
